var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title"},[_c('v-icon',{attrs:{"left":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" "+_vm._s(_vm.iconArrowLeft)+" ")]),_vm._v(" "+_vm._s(_vm.title_name)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }